(function () {
  const DESC_SELECTOR = '.product__description';
  const OFFSET = () => {
    const cssVar = getComputedStyle(document.documentElement)
      .getPropertyValue('--esim-header-offset')
      .trim();
    const n = parseFloat(cssVar);
    return (!Number.isNaN(n) && n > 0) ? n : 91;
  };

  const state = {
    sections: [],
    current: 0,
    ticking: false,
    inited: false,
    lastY: 0,
    scrollDir: 'down' // 'up' | 'down'
  };

  function $all(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }
  function $(sel, root = document) { return root.querySelector(sel); }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  // ✅ 把商品區（.product__title）也當成第一個目錄項
  function getProductSection(host) {
    const titleEl = host.querySelector('.product__title') || document.querySelector('.product__title');
    if (!titleEl) return null;

    if (!titleEl.id) titleEl.id = 'esim-product-top';
    return {
      id: titleEl.id,
      title: '商品選擇',
      el: titleEl
    };
  }

  function getSections() {
    const host = document.querySelector('product-info') || document;

    const list = [];
    const productTop = getProductSection(host);
    if (productTop) list.push(productTop);

    const desc = host.querySelector(DESC_SELECTOR) || document.querySelector(DESC_SELECTOR);
    if (!desc) return list;

    const h3s = $all('h3[id]', desc)
      .map(h => ({
        id: h.id,
        title: (h.textContent || '').trim().replace(/\s+/g, ' '),
        el: h
      }))
      .filter(s => s.title);

    return list.concat(h3s);
  }

  function setTexts(title, countText) {
    $all('[data-esim-toc-title]').forEach(el => el.textContent = title);
    $all('[data-esim-toc-count]').forEach(el => el.textContent = countText);
  }

  function renderList(sections) {
    const list = $('[data-esim-toc-list]');
    if (!list) return;

    list.innerHTML = sections.map((s, i) => (
      `<div class="esim-item" data-idx="${i}" role="button" tabindex="0">
        <span>${escapeHtml(s.title)}</span>
        <small>${i + 1}/${sections.length}</small>
      </div>`
    )).join('');
  }

  function setActive(i) {
    const sections = state.sections;
    if (!sections.length) return;

    const idx = Math.max(0, Math.min(i, sections.length - 1));
    if (idx === state.current) return;

    state.current = idx;
    setTexts(sections[idx].title, `${idx + 1}/${sections.length}`);

    const list = $('[data-esim-toc-list]');
    if (!list) return;

    $all('.esim-item', list).forEach(n => n.classList.remove('is-active'));
    const activeNode = list.querySelector(`.esim-item[data-idx="${idx}"]`);
    if (activeNode) activeNode.classList.add('is-active');
  }

  // ✅ 只有「往上」才用 91px 門檻，往下用小門檻（header 收起）
  function computeActiveIndex() {
    const sections = state.sections;
    if (!sections.length) return 0;

    const threshold = (state.scrollDir === 'up')
      ? (OFFSET() + 18)
      : 18;

    let active = 0;
    for (let i = 0; i < sections.length; i++) {
      const top = sections[i].el.getBoundingClientRect().top;
      if (top <= threshold) active = i;
      else break;
    }
    return active;
  }

  function updateBorderProgress() {
    const wrap = $('[data-esim-progress-wrap]');
    if (!wrap) return;

    const doc = document.documentElement;
    const scrollTop = window.pageYOffset || doc.scrollTop || 0;
    const max = (doc.scrollHeight || 0) - window.innerHeight;
    const ratio = max > 0 ? Math.min(1, Math.max(0, scrollTop / max)) : 0;

    document.documentElement.style.setProperty('--esim-progress', String(ratio));
  }

  function onScroll() {
    if (state.ticking) return;
    state.ticking = true;

    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    state.scrollDir = (y < state.lastY) ? 'up' : 'down';
    state.lastY = y;

    requestAnimationFrame(() => {
      state.ticking = false;
      setActive(computeActiveIndex());
      updateBorderProgress();
    });
  }

  function openDrawer() {
    const drawer = $('[data-esim-toc-drawer]');
    document.documentElement.classList.add('esim-navOpen');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    const drawer = $('[data-esim-toc-drawer]');
    document.documentElement.classList.remove('esim-navOpen');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  // ✅ 點擊跳轉：只有「往上跳」才扣 91；往下跳就不扣（header 會收起）
  function scrollToIndex(i) {
    const s = state.sections[i];
    if (!s) return;

    const currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const rect = s.el.getBoundingClientRect();
    const targetAbs = currentY + rect.top;

    const useOffset = (targetAbs < currentY) ? OFFSET() : 0;
    const y = targetAbs - useOffset - 10;

    closeDrawer();

    const prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: prefersReduce ? 'auto' : 'smooth' });
  }

  function bindUI() {
    const mask = $('[data-esim-toc-mask]');
    const closeBtn = $('[data-esim-toc-close]');
    const list = $('[data-esim-toc-list]');

    $all('[data-esim-toc-open]').forEach(btn => {
      btn.addEventListener('click', openDrawer);
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDrawer(); }
      });
    });

    if (mask) mask.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    if (list) {
      list.addEventListener('click', (e) => {
        const item = e.target.closest('.esim-item');
        if (!item) return;
        scrollToIndex(parseInt(item.dataset.idx, 10));
      });

      list.addEventListener('keydown', (e) => {
        const item = e.target.closest('.esim-item');
        if (!item) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToIndex(parseInt(item.dataset.idx, 10));
        }
      });
    }
  }

  function mountOrHide() {
    const has = state.sections.length > 0;
    const float = $('[data-esim-toc]');
    const mask = $('[data-esim-toc-mask]');
    const drawer = $('[data-esim-toc-drawer]');

    if (!has) {
      if (float) float.style.display = 'none';
      if (mask) mask.style.display = 'none';
      if (drawer) drawer.style.display = 'none';
      return;
    }

    if (float) float.style.display = '';
    if (mask) mask.style.display = '';
    if (drawer) drawer.style.display = '';
  }

  function rebuild() {
    state.sections = getSections();
    state.current = 0;

    mountOrHide();
    renderList(state.sections);

    if (state.sections.length) {
      setTexts(state.sections[0].title, `1/${state.sections.length}`);
      setActive(computeActiveIndex());
    }

    updateBorderProgress();
  }

  function init() {
    if (state.inited) return;
    state.inited = true;

    state.lastY = window.pageYOffset || document.documentElement.scrollTop || 0;

    bindUI();
    rebuild();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      setActive(computeActiveIndex());
      updateBorderProgress();
    }, { passive: true });

    const host = document.querySelector('product-info') || document;
    const desc = host.querySelector(DESC_SELECTOR) || document.querySelector(DESC_SELECTOR);

    if (desc) {
      const mo = new MutationObserver(() => rebuild());
      mo.observe(desc, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', rebuild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();